import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  editDialog: {
    "& .MuiDialog-paper": {
      padding: "10px",
    },
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  contentRoot: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      justifyContent: "unset",
      display: "block",
    },
  },
  amountContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: "10px",
    padding: "0px 8px",
    boxSizing: "border-box",
  },
  commentContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: "10px",
    padding: "0px 8px",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
    marginTop: "10px",
  },
  cancelButton: {
    marginLeft: "5px",
  },
  currentLabel: {
    padding: "0px 8px",
  },
  pointsAdjustmentContainer: {
    marginTop: "10px",
    justifyContent: "flex-end",
    padding: "0px 8px",
    boxSizing: "border-box",
  },
  showPoints: {
    visibility: "visible",
  },
  hidePoints: {
    visibility: "hidden",
  },
}));
